import React from "react";
import { motion } from "framer-motion";

const Encabezado = () => {
  return (
    <header id="home" className="px-4 mt-10 lg:mt-36 mb-36 sm:px-8">
      <div className="flex flex-col-reverse items-center gap-10 md:flex-row md:items-start">
        <div className="w-full md:w-[1000px]">
          <motion.h1
            className="mt-10 text-4xl sm:text-5xl lg:text-7xl"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            Karolis Tamosaitis Kembre
          </motion.h1>
          <motion.h1
            className="mt-5 text-2xl sm:text-3xl lg:text-5xl"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            Desarrollador Full Stack junior
          </motion.h1>
          <motion.p
            className="mt-5 text-base lg:text-lg"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.5 }}
          >
            Soy un desarrollador apasionado por la tecnología y el aprendizaje
            continuo. Me encanta resolver problemas y crear soluciones
            innovadoras.
          </motion.p>
          <div className="flex gap-5">
            <div className="flex gap-5 mt-10 text-base sm:text-lg">
              <motion.a
                href="https://www.linkedin.com/in/karolis-tamosaitis/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-6 py-3 text-center text-white bg-transparent border-2 border-gray-800 rounded-lg hover:bg-gray-900"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.7 }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.98 }}
              >
                LinkedIn
              </motion.a>
            </div>
            <div className="flex gap-5 mt-10 text-base sm:text-lg">
              <motion.a
                href="https://github.com/KarolisTK"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-6 py-3 text-center text-white bg-transparent border-2 border-gray-800 rounded-lg hover:bg-gray-900"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.7 }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.98 }}
              >
                GitHub
              </motion.a>
            </div>
          </div>
        </div>
        <motion.div
          className="hidden mx-auto -mt-48 -mb-48 lg:block"
          initial={{ opacity: 0, x: 300, scale: 0.75 }}
          animate={{ opacity: 1, x: 0, scale: 0.75 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <div className="relative w-full h-full">
            <img
              src="https://res.cloudinary.com/dhjl9tw4r/image/upload/v1748341962/Imagen_de_WhatsApp_2025-05-27_a_las_12.29.25_31f9d146_1_tkyhst.png"
              alt="Karolis Tamosaitis"
              className="block w-full h-auto"
            />
            <div className="absolute bottom-0 left-0 w-full h-24 pointer-events-none bg-gradient-to-t from-black to-transparent"></div>
          </div>
        </motion.div>
      </div>
    </header>
  );
};

export default Encabezado;
